import posthog from 'posthog-js';

/** Content-free browser-side timing for the Canvas readiness boundary. */
export interface CanvasOperationMetric {
  phase: 'readiness';
  outcome: 'qualified' | 'unqualified' | 'stale_mount' | 'no_revision' | 'no_connection';
  durationMs: number;
  letterheadResource: 'available' | 'unavailable' | 'not_required';
}

/**
 * Records only stage, outcome and latency. No document text, block ids,
 * conversation ids, filenames or tool arguments cross this boundary.
 */
export function captureCanvasOperationMetric(metric: CanvasOperationMetric): void {
  const properties = {
    schema_version: 1,
    feature: 'redaction_web_canvas',
    phase: metric.phase,
    outcome: metric.outcome,
    duration_ms: Math.max(0, Math.round(metric.durationMs)),
    letterhead_resource: metric.letterheadResource,
  };
  try {
    posthog.capture('canvas_operation_metric', properties);
  } catch {
    // Telemetry must never prevent the document from becoming available.
  }
  try {
    console.info('[CANVAS_OPERATION_METRIC]', properties);
  } catch {
    // Some embedded browsers replace console with a non-standard facade.
  }
}
